import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface FilterBarProps {
  children: ReactNode;
  /** Optional trailing slot for an action button (Reset / Export). */
  actions?: ReactNode;
  className?: string;
  sticky?: boolean;
}

export function FilterBar({ children, actions, className, sticky = false }: FilterBarProps) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-end gap-12 rounded-lg border border-neutral-200 bg-neutral-0 p-16',
        sticky && 'tablet:sticky tablet:top-0 tablet:z-[--z-sticky]',
        className,
      )}
    >
      <div className="flex flex-wrap items-end gap-12 flex-1">{children}</div>
      {actions && <div className="flex items-end gap-8">{actions}</div>}
    </div>
  );
}
